import { toBoolOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type { IAssessTobaccoFormValues, IAssessTobaccoModel, IAssessTobaccoSubmitResult } from '@/types/screening/assess-tobacco';

const ASSESS_TOBACCO_ENDPOINT = '/api/register/assess-tobacco';

const defaultAssessTobaccoModel: IAssessTobaccoModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessTobacco,

    hasUsedTobacco: null,
    usesTobacco: null,
    willStopTobaccoUse: null,
};

export const useAssessTobacco = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_TOBACCO_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessTobaccoModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IAssessTobaccoFormValues, DashRegistrationStep, IAssessTobaccoSubmitResult>(
        url,
        (values) => {
            // Each follow-up only applies when its parent answer is "Yes".
            const hasUsedTobacco = toBoolOrNull(values.hasUsedTobacco);
            const usesTobacco = hasUsedTobacco === true ? toBoolOrNull(values.usesTobacco) : null;
            const willStopTobaccoUse = usesTobacco === true ? toBoolOrNull(values.willStopTobaccoUse) : null;

            return {
                hasUsedTobacco,
                usesTobacco,
                willStopTobaccoUse,
            };
        },
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
